// import moment from 'moment';

const getters = {
    tempDate(state) {
        return state;
    }
};

export default getters;